import { render, staticRenderFns } from "./klyr20250617.vue?vue&type=template&id=0c6b642a&"
import script from "./klyr20250617.vue?vue&type=script&lang=js&"
export * from "./klyr20250617.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType2: require('D:/Project/kpwebsite/PC/components/content/content-type-2.vue').default})
